import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import KeyValue from "../classes/KeyValue";
import PropriedadeParceiro from "../classes/PropriedadeParceiro";


interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "ParceiroPropriedade/All/" },
  { method: "GET", rota: "ParceiroPropriedade/" },
  { method: "POST", rota: "ParceiroPropriedade/Adicionar" },
  { method: "PUT", rota: "ParceiroPropriedade/Atualizar" },
  { method: "POST", rota: "ParceiroPropriedade/Apagar" },
  { method: "POST", rota: "ParceiroPropriedade/Listar/ModalidadeProducao/Centro/" },
  { method: "GET", rota: "ParceiroPropriedade/RecuperaCentroIndustrializacaoDoParceiro" }
];

const cacheKey: string = "PropriedadeParceiroCache";
const cacheKeySelC: string = "PropriedadeParceiroCacheSelecionado";

const apiServico: String = "PORTAL"

class PropriedadeParceiroDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }
  Adicionar(value: PropriedadeParceiro) {
    let ok: boolean = false;
    let error: any = undefined;
    super.post(calls[2].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  Atualizar(value: PropriedadeParceiro) {
    let ok: boolean = false;
    let error: any = undefined;
    super.put(calls[3].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  Apagar(value: PropriedadeParceiro) {
    let ok: boolean = false;
    let error: any = undefined;
    super.post(calls[4].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  async ListarAtivos(codigoFornecedorSap: number): Promise<PropriedadeParceiro[]> {
    return await super.Get(calls[0].rota + codigoFornecedorSap)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }  
  
  async RecuperarPorId(id: number): Promise<PropriedadeParceiro> {
    return await super.Get(calls[1].rota + id)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async ListarCentrosVirtuais(codigoFornecedorSap: number): Promise<KeyValue[]> {
    return await super.post(calls[5].rota + codigoFornecedorSap, '')
      .then((response) => {
        return JSON.parse(JSON.stringify(response));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async getCentroIndustrializacao(codigoFornecedorSap: number): Promise<string> {
    let ok: boolean = false;
    let data: string = "";
    let error: any = undefined;
    let url:string = `${calls[6].rota}/${codigoFornecedorSap}`
    await super
      .post(url, codigoFornecedorSap)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
        data = response.toString();
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<string>((resolve) => {
      resolve(data);
    });
  }

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  ListarFromCache(): PropriedadeParceiro[] {
    let result: PropriedadeParceiro[] = JSON.parse(cacheKey);
    return result;
  }

  AdicionarListaAoCache(value: PropriedadeParceiro[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }

}
export default PropriedadeParceiroDataset;

